import React from 'react';
import SystemNotifications from './SystemNotifications';
import TabButton from './TabButton';

const ServicesOverview = ({ servicesData, notificationsData }) => {
  const [ activeService, setActiveService ] = React.useState(servicesData[0]);
  const [ notifications, setNotifications ] = React.useState(notificationsData);

  const activeNotifications = notifications[activeService.id];

  return (
    <div className="d-flex">
      <div className="services-tabs">
        {servicesData.map((service) =>
          <TabButton
            key={`tab-${service.id}`}
            service={service}
            selected={activeService == service}
            notifications={notifications}
            handleClick={setActiveService}
          />
        )}
      </div>
      <div className="service-content">
        <div className="service-info">
          <div>
            <h5>{activeService.name}</h5>
            {activeService.description ? <p>{activeService.description}</p> : ""}
            {
              activeService.show_maintenance_policy ?
                <p>This service has an active subscription.</p> : ""
            }
          </div>
          <div className="btn-flex-group">
            <CreateCaseButton activeService={activeService} />
            {
              activeService.show_maintenance_policy ?
              <button
                type="button"
                className="btn btn-primary"
                data-toggle="modal"
                data-target={`#${activeService.maintenance_policy_modal_id}`}
              >
                View subscription policies
              </button> : ""
            }
          </div>
        </div>
        {
          activeNotifications && activeNotifications.length > 0 ?
            <SystemNotifications
              activeNotifications={activeNotifications}
              setNotifications={setNotifications}
              activeServiceID={activeService.id}
            /> : ""
        }
      </div>
    </div>
  );
}

const CreateCaseButton = ({ activeService }) => {
  const existingButton = (
    <a
      href={activeService.button_disabled ? undefined : activeService.button_path}
      className={`btn btn-orange create-case-btn ${activeService.button_disabled ? "disabled" : ""}`}
      title={activeService.button_disabled ? activeService.button_disabled_reason : "Create case"}
      onClick={(e) => {
        if (activeService.button_disabled)
          e.preventDefault();
      }}
    >
      Create case
    </a>
  )

  if (activeService.button_disabled) {
    return existingButton
  }

  const existingLink = (
    <a href={activeService.button_path} className="dropdown-item">
      Create case
    </a>
  )
  const newWorkflowLink = (
    <a href={activeService.button_new_workflow_path} className="dropdown-item">
      New case workflow (beta)
    </a>
  )
  return (
    <div className="btn-group d-flex mt-1">
      {existingButton}
      <button type="button" className="btn btn-orange dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false">
        <span className="sr-only">Toggle Dropdown</span>
      </button>
      <div className="dropdown-menu flex-column">
        {existingLink}
        {newWorkflowLink}
      </div>
    </div>
  )
}

export default ServicesOverview;
